"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FormStore_1 = require("./FormStore");
const FormContext_1 = require("./FormContext");
const lib_1 = require("../../lib");
const useForm_1 = require("./hooks/useForm");
const FormField_1 = require("./FormField");
const FormFieldArray_1 = require("./FormFieldArray");
const FormGroup_1 = require("./FormGroup");
const FormSection_1 = require("./FormSection");
const getNewStore = (props) => {
    return new FormStore_1.FormStore(props.initialValues);
};
const FormContent = ({ className, children, onSubmit, resetOnUnmount, initialValues, disableValidation }) => {
    const { handleSubmit, subscribeToSubmit, reset, store } = (0, useForm_1.useForm)();
    (0, react_1.useEffect)(() => {
        const unsubscribe = subscribeToSubmit((...args) => {
            if (onSubmit)
                onSubmit(...args);
        });
        return () => {
            unsubscribe();
        };
    }, [onSubmit]);
    (0, react_1.useEffect)(() => {
        return () => {
            if (resetOnUnmount) {
                reset();
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        store.setState(state => (Object.assign(Object.assign({}, state), { disableValidation })));
    }, [disableValidation]);
    (0, react_1.useMemo)(() => {
        if (initialValues) {
            store.initialState = Object.assign(Object.assign({}, store.initialState), { values: initialValues });
            store.setState(state => (Object.assign(Object.assign({}, state), { values: initialValues })));
        }
    }, [initialValues]);
    return ((0, jsx_runtime_1.jsx)("form", Object.assign({ className: (0, lib_1.classnames)('form', className), onSubmit: handleSubmit }, { children: children }), void 0));
};
const FormProvider = props => {
    const store = (0, react_1.useMemo)(() => {
        return props.store || getNewStore(props);
    }, []);
    const [str, setStr] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        return store.subscribe(() => {
            setStr({});
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(FormContext_1.FormContext.Provider, Object.assign({ value: { fire: str, store } }, { children: (0, jsx_runtime_1.jsx)(FormContent, Object.assign({}, props), void 0) }), void 0));
};
class Form extends react_1.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(FormProvider, Object.assign({}, this.props), void 0);
    }
}
exports.Form = Form;
Form.Field = FormField_1.FormField;
Form.FieldArray = FormFieldArray_1.FormFieldArray;
Form.ContextConsumer = FormContext_1.FormContext.Provider;
Form.Group = FormGroup_1.FormGroup;
Form.Section = FormSection_1.FormSection;
//# sourceMappingURL=Form.js.map